import styled from "styled-components";

export const RunPageWrapper = styled.div`
.spacer {
    margin-top: 24px;
    margin-bottom: 24px;
}
`;